// Libraries
import React, {forwardRef} from 'react'
import classnames from 'classnames'

// Types
import {StandardFunctionProps, InfluxColors} from '../../../../Types'

// Styles
import '../../InfluxLogo.scss'

export type InfluxDbRef = SVGSVGElement
export interface InfluxDbProps extends StandardFunctionProps {
  /** Coloration of the SVG image */
  fill?: InfluxColors | string
}

export const InfluxDb = forwardRef<InfluxDbRef, InfluxDbProps>(
  (
    {
      className = '',
      id = 'svg--influxdata',
      fill = InfluxColors.White,
      testID = 'svg--influxdata',
    },
    ref
  ) => {
    const logoClass = classnames('cf-logo', {
      [`${className}`]: className,
    })

    const logoStyle = {fill, marginTop: '4.5px'}

    return (
      <svg
        version="1.1"
        id={id}
        data-testid={testID}
        style={logoStyle}
        x="0px"
        y="0px"
        viewBox="0 0 417 84"
        width="154"
        height="31"
        ref={ref}
      >
        <path
          className={logoClass}
          d="M11.058 21.945c-2.884 0-5.332-.938-7.344-2.816C1.77 17.25.797 14.97.797 12.289c0-2.817.973-5.13 2.917-6.941C5.726 3.47 8.174 2.53 11.058 2.53c2.883 0 5.298.939 7.242 2.817 1.945 1.81 2.918 4.124 2.918 6.94 0 2.683-.973 4.963-2.918 6.84-1.944 1.879-4.359 2.817-7.242 2.817ZM1.904 82V30.094H20.11V82H1.904Zm30.453 0V30.094h17.906l.2 6.438c1.342-2.549 3.32-4.527 5.936-5.935 2.615-1.409 5.633-2.113 9.053-2.113 5.835 0 10.26 1.878 13.279 5.633 3.085 3.689 4.627 9.12 4.627 16.297V82H65.15V53.834c0-6.103-2.313-9.154-6.94-9.154-2.482 0-4.393.871-5.734 2.615-1.274 1.677-1.912 4.09-1.912 7.243V82H32.357Zm68.202 0V44.68H92.21V30.094h8.349v-5.03c0-7.98 1.945-14.15 5.835-18.51 3.957-4.358 9.523-6.538 16.699-6.538 2.078 0 4.023.168 5.834.503 1.878.268 3.454.67 4.728 1.207l-.905 15.09c-.738-.336-1.644-.57-2.717-.705a14.395 14.395 0 0 0-2.816-.302c-2.884 0-5.03.839-6.438 2.515-1.341 1.677-2.012 4.326-2.012 7.947v3.823h12.272V44.68h-12.272V82h-18.208Zm38.528 0V.519h18.207V82h-18.207Zm47.607 1.61c-5.701 0-10.06-1.811-13.077-5.433-3.018-3.688-4.527-9.053-4.527-16.095V30.094h18.308V58.36c0 3.084.536 5.364 1.609 6.84 1.14 1.475 2.918 2.213 5.332 2.213 2.414 0 4.258-.838 5.533-2.515 1.341-1.744 2.011-4.191 2.011-7.343V30.094h18.208V82h-17.906l-.201-6.438c-1.341 2.548-3.353 4.527-6.036 5.935-2.615 1.408-5.7 2.112-9.254 2.112ZM228.342 82l18.912-26.758-17.906-25.148h20.32l8.45 14.083 8.248-14.083h19.314l-17.805 25.35L286.888 82h-20.421l-9.456-15.693L247.656 82h-19.314Zm90.434 1.61c-4.628 0-8.785-1.14-12.474-3.42-3.621-2.28-6.471-5.433-8.55-9.456-2.079-4.091-3.119-8.719-3.119-13.882 0-4.963 1.107-9.456 3.32-13.48 2.28-4.09 5.331-7.31 9.154-9.657 3.822-2.414 8.047-3.621 12.675-3.621 3.822 0 7.31.938 10.461 2.816 3.219 1.878 5.801 4.527 7.746 7.947V.52h8.551V82h-8.35l-.201-9.154c-2.012 3.42-4.661 6.07-7.947 7.947-3.286 1.878-7.041 2.816-11.266 2.816Zm2.213-7.646c3.487 0 6.538-.804 9.154-2.414 2.615-1.61 4.661-3.856 6.136-6.74 1.543-2.883 2.314-6.203 2.314-9.959 0-3.755-.771-7.075-2.314-9.958-1.475-2.884-3.521-5.13-6.136-6.74-2.616-1.61-5.667-2.414-9.154-2.414-3.42 0-6.472.805-9.154 2.414-2.616 1.61-4.695 3.856-6.237 6.74-1.475 2.883-2.213 6.203-2.213 9.959 0 3.755.738 7.075 2.213 9.958 1.542 2.884 3.621 5.13 6.237 6.74 2.682 1.61 5.734 2.414 9.154 2.414Zm70.429 7.645c-3.957 0-7.545-.938-10.764-2.816-3.152-1.878-5.633-4.527-7.444-7.947L373.009 82h-8.349V.519h8.55v40.338c2.012-3.42 4.661-6.069 7.947-7.947 3.286-1.877 7.042-2.816 11.267-2.816 4.694 0 8.852 1.14 12.473 3.42 3.622 2.28 6.472 5.432 8.551 9.456 2.079 4.023 3.118 8.65 3.118 13.882 0 4.962-1.14 9.489-3.42 13.58-2.213 4.023-5.231 7.242-9.053 9.657-3.756 2.347-7.981 3.52-12.675 3.52Zm-1.207-7.645c3.487 0 6.538-.804 9.154-2.414 2.615-1.61 4.661-3.856 6.136-6.74 1.542-2.883 2.314-6.203 2.314-9.959 0-3.755-.772-7.075-2.314-9.958-1.475-2.884-3.521-5.13-6.136-6.74-2.616-1.61-5.667-2.414-9.154-2.414-3.42 0-6.472.805-9.154 2.414-2.616 1.61-4.695 3.856-6.237 6.74-1.476 2.883-2.213 6.203-2.213 9.959 0 3.755.737 7.075 2.213 9.958 1.542 2.884 3.621 5.13 6.237 6.74 2.682 1.61 5.734 2.414 9.154 2.414Z"
        />
      </svg>
    )
  }
)

InfluxDb.displayName = 'InfluxDb'
